import React from "react";
import sfuLogo from "../../assets/img/sfu-logo@2x.png";
import sfuLogoOnly from "../../assets/img/sfu-logo-only@2x.png";
import { useScholarshipId } from "../../hooks/useScholarshipId";

export default function PageWrapper({ children, scholarship }) {
  const scholarshipData = useScholarshipId();
  let scholarshipType = "Uggla Family Scholarship";
  let mailTo = "mailto:sfu_uggla_scholars@sfu.ca";
  let email = "sfu_uggla_scholars@sfu.ca";
  if (scholarship !== undefined && scholarship === "fas-scholarship") {
    scholarshipType = "FAS Scholarship";
    mailTo = "mailto:sfu_fas_scholars@sfu.ca";
    email = "sfu_fas_scholars@sfu.ca";
  }
  return (
    <>
      <header>
        <div className="p-grid p-nogutter">
          <div className="p-col-12">
            <div>
              <img src={sfuLogoOnly} alt="sfu-logo" />
            </div>
          </div>

          <div className="p-col-12">
            <div>
              <img src={sfuLogo} alt="sfu-logo" />
              <p>{scholarshipType}</p>
            </div>
          </div>
        </div>
      </header>
      {scholarshipData.data &&
        scholarshipData.data.tracs_outage_banner_messages && (
          <div className="outage-banner-container">
            {scholarshipData.data.tracs_outage_banner_messages.map(
              (message) => (
                <div
                  key={message}
                  className="alert alert-danger"
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginLeft: "20px",
                    marginRight: "20px",
                  }}
                >
                  {message}
                </div>
              )
            )}
          </div>
        )}
      <div className="page-content">{children}</div>
      <footer>
        <p>
          For support, please contact:{" "}
          <a href={mailTo} target="_blank" rel="noreferrer">
            {email}
          </a>
        </p>
      </footer>
    </>
  );
}
